import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import api from "@/lib/api";
import { fmtDate } from "@/utils/format";

const STATUS = {
  expired: { cls: "bg-[#FF3B30] text-white border-[#FF3B30]", label: "Süresi Dolmuş" },
  expiring_soon: { cls: "bg-[#FF9500] text-white border-[#FF9500]", label: "Yakında Dolacak" },
};

export const HseExpiringWidget = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => {
    const load = () => api.get(`/hse/expiring?_ts=${Date.now()}`)
      .then(({ data }) => setItems(data.items || []))
      .catch(() => setItems([]));
    load();
    const id = setInterval(() => { if (!document.hidden) load(); }, 120_000);
    return () => clearInterval(id);
  }, []);

  const expiredCount = (items || []).filter((i) => i.status === "expired").length;

  return (
    <div className="bg-white border-2 border-[#09090B] border-l-[6px] border-l-[#FF9500] p-5" data-testid="dashboard-hse-widget">
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <ShieldAlert size={18} />
          <div className="font-heading text-lg tracking-tight">İSG Belge Takibi</div>
        </div>
        <div className="text-[10px] font-mono uppercase text-neutral-500" data-testid="hse-widget-counts">
          {items ? `${items.length} belge · ${expiredCount} dolmuş` : "…"}
        </div>
      </div>
      {items === null ? (
        <div className="text-sm text-neutral-500 py-4">Yükleniyor…</div>
      ) : items.length === 0 ? (
        <div className="text-sm text-neutral-500 py-4" data-testid="hse-widget-empty">
          Geçerliliğine 30 gün veya daha az kalan belge yok.
        </div>
      ) : (
        <div className="max-h-72 overflow-y-auto divide-y divide-neutral-200 border-t-2 border-[#09090B]">
          {items.map((it) => {
            const s = STATUS[it.status];
            return (
              <button key={`${it.scope}-${it.personnel_id}-${it.doc_type}`} type="button"
                onClick={() => navigate("/isg")}
                className="w-full text-left flex items-center gap-3 py-2 px-1 hover:bg-neutral-50 transition-colors"
                data-testid={`hse-widget-row-${it.scope}-${it.personnel_id || "company"}-${it.doc_type}`}>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold truncate">
                    {it.title}
                    {it.note && <span className="font-normal text-neutral-600" data-testid="hse-widget-note"> · {it.note}</span>}
                  </div>
                  <div className="text-[11px] font-mono text-neutral-500 truncate">
                    {it.scope === "company" ? "Şirket Belgesi" : `Personel · ${it.owner}`} · {fmtDate(it.expiry_date)}
                  </div>
                </div>
                <div className={`text-sm font-mono font-bold whitespace-nowrap ${it.days_left < 0 ? "text-[#FF3B30]" : "text-[#FF9500]"}`}
                  data-testid="hse-widget-days-left">
                  {it.days_left} gün
                </div>
                <span className={`inline-block px-2 py-0.5 text-[10px] font-mono uppercase border-2 whitespace-nowrap ${s.cls}`}>{s.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
